export var EntityType;
(function (EntityType) {
    EntityType["Planting"] = "Planting";
    // Ranch = "Ranch",
    // Lot = "Lot"
})(EntityType || (EntityType = {}));
